import { createApiRef } from '@backstage/core-plugin-api';

import type { AuditLogEntry, AuditLogSearchParams, PagedResult } from './types';

/**
 * Client of the TDMS Audit Log service.
 *
 * UI and host applications depend on this contract; the plugin supplies its
 * default implementation through the Backstage API factory.
 */
export interface AuditLogApi {
  /** Search stored audit log entries with server-side filtering, sorting and paging. */
  searchLogs(params: AuditLogSearchParams): Promise<PagedResult<AuditLogEntry>>;
  /** Fetch a single entry by id; rejects with a `ResponseError` (404) when unknown. */
  getLogById(id: string, signal?: AbortSignal): Promise<AuditLogEntry>;
}

export const auditLogApiRef = createApiRef<AuditLogApi>({
  id: 'plugin.audit-log.api',
});
